module.exports = __webpack_public_path__ + "img/herramientas_paso2.58e1aa9e.svg";